import './attachment_input_component.scss'
import { Controller } from 'stimulus'
import Dropzone from 'dropzone'
import DirectUploadHelper from 'helpers/direct_upload_helper'
import { getMetaValue, removeElement } from 'helpers'

export default class extends Controller {
  static targets = ['input', 'dropzone', 'checkbox']
  static values = {
    fileExtensions: String,
    maxFiles: Number,
    attachmentUrl: String,
    attachmentFilename: String,
    attachmentByteSize: Number
  }

  connect = (): void => {
    this.createDropZone()
    this.bindEvents()
    this.displayExistingAttachment()
  }

  createDropZone = (): void => {
    this.dropZone = new Dropzone(this.dropzoneTarget, {
      url: this.url,
      headers: this.headers,
      maxFiles: this.maxFilesValue,
      thumbnailWidth: 320,
      thumbnailHeight: 320,
      addRemoveLinks: true,
      acceptedFiles: this.fileExtensionsValue,
      autoQueue: false
    })
  }

  bindEvents = (): void => {
    this.dropZone.on('addedfile', file => {
      setTimeout(() => {
        this.createDirectUploadHelper(this, file).start()
      }, 500)
    })

    this.dropZone.on('success', (file, response) => {
      this.checkboxTarget.checked = false
    })

    this.dropZone.on('removedfile', file => {
      this.checkboxTarget.checked = true
      if (file.controller != null) {
        removeElement(file.controller.hiddenInput)
      }
    })

    this.dropZone.on('canceled', file => {
      file.controller?.xhr?.abort()
    })

    this.dropZone.on('error', (file, errorMessage) => {
      console.error('Dropzone error:', errorMessage, file)
    })

    this.dropZone.on('rejected', (rejectedFiles) => {
      console.warn('Files rejected:', rejectedFiles)
      rejectedFiles.forEach(file => {
        console.log('Rejected file type:', file.type, 'Name:', file.name)
      })
    })
  }

  createDirectUploadHelper = (source, file): DirectUploadHelper => {
    return new DirectUploadHelper(source, file)
  }

  displayExistingAttachment = (): void => {
    const attachmentUrl = this.attachmentUrlValue
    if (attachmentUrl !== null && attachmentUrl !== '' && attachmentUrl !== undefined) {
      const mockFile = { name: this.attachmentFilenameValue, size: this.attachmentByteSizeValue, accepted: true, kind: 'attachment' }

      const callback = null
      const crossOrigin = null
      const resizeThumbnail = false

      this.dropZone.displayExistingFile(mockFile, attachmentUrl, callback, crossOrigin, resizeThumbnail)
      this.dropZone.files.push(mockFile)
    }
  }

  get headers (): object {
    return { 'X-CSRF-Token': getMetaValue('csrf-token') }
  }

  get url (): string {
    return this.inputTarget.getAttribute('data-direct-upload-url')
  }

  disconnect = (): void => {
    Dropzone.forElement(this.dropzoneTarget).destroy()
  }
}
